import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Tabs, Badge } from 'antd';
import { UserOutlined, TeamOutlined, BookOutlined } from '@ant-design/icons';
import { selectAgents, selectSkills, selectTeams, useContactStore } from 'stores/nic/stores/contactStore';
import { DirectoryType } from './DirectoryComponent';
export var DirectoryNavigation = function (_a) {
    var onTypeChange = _a.onTypeChange, activeType = _a.activeType;
    var agents = useContactStore(selectAgents);
    var teams = useContactStore(selectTeams);
    var skills = useContactStore(selectSkills);
    var items = [
        {
            key: DirectoryType.AGENTS,
            label: (_jsxs("span", { children: [_jsx(UserOutlined, {}), _jsx(Badge, { count: agents === null || agents === void 0 ? void 0 : agents.length, size: "small", offset: [8, -2], children: "Agents" })] }))
        },
        {
            key: DirectoryType.TEAMS,
            label: (_jsxs("span", { children: [_jsx(TeamOutlined, {}), _jsx(Badge, { count: teams === null || teams === void 0 ? void 0 : teams.length, size: "small", offset: [8, -2], children: "Teams" })] }))
        },
        {
            key: DirectoryType.SKILLS,
            label: (_jsxs("span", { children: [_jsx(BookOutlined, {}), _jsx(Badge, { count: skills === null || skills === void 0 ? void 0 : skills.length, size: "small", offset: [8, -2], children: "Skills" })] }))
        }
    ];
    return (_jsx(Tabs, { activeKey: activeType, onChange: function (key) { return onTypeChange(key); }, items: items, size: "small", tabPlacement: "top" }));
};
